import CarouselBox from 'components/CarouselBox';

import ArticleCarouselItem from './ArticleCarouselItem';

import APP from 'constants/app';

const ARTICLES = [
  {
    link: 'https://oglobo.globo.com/economia/negocios/noticia/2023/11/24/a-hora-e-essa-comecou-a-black-friday-veja-os-melhores-horarios-para-garimpar-descontos-hoje.ghtml',
    logoName: 'globo.svg',
    media: 'O Globo',
    publishDate: '24/11/2023',
    text: 'Se você planeja comprar alguma coisa na promoção deste ano, um levantamento realizado pelo Promobit, plataforma especializada em ofertas e descontos, aponta que a madrugada é o horário que concentra o maior volume de promoções nas plataformas de e-commerce. Nos últimos três anos, os picos ocorreram entre 22h de quinta e 01h de sexta.',
  },
  {
    link: 'https://valorinveste.globo.com/objetivo/gastar-bem/noticia/2019/11/05/quais-os-produtos-mais-entram-em-oferta-na-black-friday.ghtml',
    logoName: 'valor.svg',
    media: 'Valor',
    publishDate: '05/11/2019',
    text: 'No Brasil, as promoções não acontecem só no dia, a última sexta-feira do mês. Alguns varejistas anunciam semanas inteiras de descontos. De acordo com os dados do site de anúncio de promoções Promobit, o número de ofertas cresce 124% no mês de novembro, variação que ocorre em todas as categorias de produtos.',
  },
  {
    link: 'https://exame.com/negocios/qual-e-o-melhor-horario-para-comprar-na-black-friday-2023/',
    logoName: 'exame.svg',
    media: 'Exame',
    publishDate: '24/11/2023',
    text: '“Na semana da Black Friday, as ofertas se intensificam e o ápice do evento começa já na quinta à tarde, onde a maior parte das ofertas começa a aparecer e vai se estendendo até a segunda-feira seguinte”, explica o Diretor de Vendas e Marketing do Promobit, Gabriel Alves.',
  },
  {
    link: 'https://www.infomoney.com.br/consumo/quem-se-deu-bem-na-black-friday-2023-levantamento-mostra-itens-com-mais-ofertas/',
    logoName: 'info-money.svg',
    media: 'InfoMoney',
    publishDate: '29/11/2023',
    text: 'Quem se deu bem na Black Friday 2023? Segundo levantamento do Promobit, plataforma que agrega ofertas online de produtos, o consumidor que adquiriu celular, video game e itens de informática obteve o maior número de oportunidades de preços mais em conta.',
  },
  {
    link: 'https://www1.folha.uol.com.br/mercado/2023/11/notebooks-celulares-iphone-e-tvs-tem-mais-ofertas-na-black-friday.shtml',
    logoName: 'folha-sp.svg',
    media: 'Folha de São Paulo',
    publishDate: '24/11/2023',
    text: '"Tudo indica que a Black Friday deste ano deve superar a do ano passado e é possível ver vários produtos de alta demanda chegando aos menores preços históricos", diz Gabriel Alves, diretor de marketing e venda da Promobit.',
  },
  {
    link: 'https://blog.nubank.com.br/tudo-sobre-black-friday/',
    logoName: 'nubank.svg',
    media: 'Nubank',
    publishDate: '31/10/2022',
    text: 'Logo no início da Black Friday no Brasil, em meados de 2010, era bastante comum ouvir que as promoções eram a "metade do dobro". Contudo, o cenário mudou em 2019, com crescimento de 124% no número de ofertas naquele ano, segundo dados da Promobit.',
  },
];

const ArticlesCarousel = () => (
  <CarouselBox
    arrowsProps={{
      className: 'hidden md:flex',
      offsetX: { left: '-left-10', right: '-right-10' },
      type: 'primary-ghost',
    }}
    carouselProps={{
      className: 'flex gap-x-4 md:gap-x-13',
    }}
    itemProps={{
      slidesPerView: 1,
      snapMode: 'snap-start',
      breakpoints: {
        md: { slidesPerView: 3 },
      },
    }}
    list={ARTICLES}
    render={({ link, logoName, media, publishDate, text }) => (
      <ArticleCarouselItem
        key={media}
        link={link}
        logo={`${APP.LOCAL_IMAGE_PATH}/features/commercial-partners/media/${logoName}`}
        media={media}
        publishDate={publishDate}
        text={text}
      />
    )}
    dots
    full
    showArrows
  />
);

export default ArticlesCarousel;
